<template>
	<div>
		<div class="row">
			<div class="exchange mt-5">
				<transfer />
			</div>
		</div>
	</div>
</template>
<script>

	import transfer from '@/components/transfer/form/transfer'
    import symForm from '@/components/form/symForm.vue'
    export default {
        name: 'sendMoney',
        components: { symForm, transfer },
        data () {
            return {
                isLoading: false,
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                Form: null,
                translationForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: []
            }
        },
        watch: {
            '$route.params.id' () {
                this.getForm();
            }
        },
        mounted () {
            this.getForm();

        },
        methods: {
            resetStatus () {
                this.formProcess = 0;
            },
	        changeUser () {
                console.log();
	        },
            async fetchRegions () {

		        this.$http.get(api+'api/v1/regions')
		            .then(response => {

		            this.regions = response.body.result.regions;
		    }, response => {

		        })
		    },
		    async updateCK () {
		        //for(var instanceName in CKEDITOR.instances)
		        //CKEDITOR.instances[instanceName].updateElement();
		    },
		    async multiSelect () {

		        var e = document.getElementsByClassName("choicesx");
		        for (var i = 0; i < e.length; i++){
		            var name = e[i].getAttribute("name");

		            var element = e[i];

		            var example = new Choices(element, {
		                removeItemButton: true,

		            });
		        }


		        //CKEDITOR.replaceAll();

		    },
		    async getForm (data) {

		        if(!this.isLoading) {
		            this.isLoading = true;
		            this.Form = null;
		            this.formProcess = 0;
		            if(data) {

		                //this.Form = null;
		                this.$http.post(api+'api/v1/send_money',
		                    data )
		                    .then(response => {

		                    this.Form = response.body.result;
		                    this.formProcess = 200;
		                    this.isLoading = false;
		                //swal('', this.t.processing.success, "success")

		                setTimeout(this.resetStatus, 5000);

		            }, response => {
		                    this.Form = response.body.result;
		                    this.formProcess = 400;
		                    this.isLoading = false;

		                    //swal(this.t.processing.error, this.t.processing.check, "error")
		                })

		            } else {
		                this.$http.get(api+'api/v1/send_money').then(response => {

		                    this.Form = response.body.result;
		                    this.formData = response.body.form_data;
		                    this.isLoading = false;

		                }, response => {
		                    this.isLoading = false;
		                    this.formProcess = response.status;
		                })
		            }
		        }
		    },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

	.exchange {
		width: 400px;
		margin: auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/transfer/sendMoney.vue